import { useState } from 'react';
import { useStorage } from '@funtech-int/web-toolkit';

import {
    SubtitlesRatio,
    subtitlesRatioValues,
} from '@/scenarios/legacy-player/components/PlayerSkin/parts/Subtitles/Subtitles.types';
import { subtitlesRatioLocalStorage } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Settings/Settings.config';
import { isSubtitlesRatio } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Subtitles/helpers';

export const useRatio = () => {
    const storage = useStorage();

    return useState<SubtitlesRatio>(() => {
        const subtitlesRatioLocal = Number(storage.local.get(subtitlesRatioLocalStorage));
        return isSubtitlesRatio(subtitlesRatioLocal)
            ? subtitlesRatioLocal
            : subtitlesRatioValues.NORMAL;
    });
};
